"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMatches = exports.isValid = void 0;

var isValid = function isValid(regex, str) {
  var re = new RegExp(regex, 'g');
  var t = str.match(re);
  return Array.isArray(t);
};

exports.isValid = isValid;

var getMatches = function getMatches(regex, str) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$flags = _ref.flags,
      flags = _ref$flags === void 0 ? 'g' : _ref$flags,
      _ref$depth = _ref.depth,
      depth = _ref$depth === void 0 ? 0 : _ref$depth;

  var re = new RegExp(regex, flags); // TODO: utils.match(str, regexp, options='g')

  var match = null;
  var matches = [];

  do {
    match = re.exec(str);

    if (match) {
      matches.push(match[depth]);
    }
  } while (match != null);

  return matches;
};

exports.getMatches = getMatches;